import { render, staticRenderFns } from "./RiskProcessDrawer.vue?vue&type=template&id=52a1d745&scoped=true"
import script from "./RiskProcessDrawer.vue?vue&type=script&lang=js"
export * from "./RiskProcessDrawer.vue?vue&type=script&lang=js"
import style0 from "./RiskProcessDrawer.vue?vue&type=style&index=0&id=52a1d745&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a1d745",
  null
  
)

export default component.exports